var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 101.549 2.113 C 87.353 6.995, 76.696 17.970, 72.595 31.932 C 69.746 41.634, 70.207 472.710, 73.077 481.228 C 82.097 508.005, 90.936 511.410, 152.500 511.819 C 253.965 512.495, 306.015 494.969, 362.068 441.257 C 518.846 291.026, 428.437 24.423, 212.789 1.052 C 193.294 -1.060, 108.425 -0.251, 101.549 2.113 M 161 256 C 161 422.318, 161 422.318, 181.250 421.686 C 406.148 414.673, 406.148 97.327, 181.250 90.314 C 161 89.682, 161 89.682, 161 256",
    stroke: "none",
    fill: "#a3a3a3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoD);
export default __webpack_public_path__ + "static/media/ico-d.298583515d6fb2ae10b8bcd12ba8922d.svg";
export { ForwardRef as ReactComponent };